import { ref, watchEffect } from 'vue'

export const useMediaQuery = (query) => {
  const matches = ref(true);

  watchEffect((onInvalidate) => {
    const media = window.matchMedia(query)

    if (media.matches !== matches.value) {
      matches.value = media.matches
    }

    const onChange = () => {
      matches.value = media.matches
    }

    // Safari <= 13 (and other old browsers) implement the deprecated
    // MediaQueryList.addListener/removeListener but not addEventListener,
    // so feature-detect and fall back to keep them from throwing.
    if (media.addEventListener) {
      media.addEventListener('change', onChange)
    } else {
      media.addListener(onChange)
    }

    onInvalidate(() => {
      if (media.removeEventListener) {
        media.removeEventListener('change', onChange)
      } else {
        media.removeListener(onChange)
      }
    })
  })

  return matches
}
